<fadv-grid *ngIf="showAlert" class="alert-container">
    <fadv-grid-row class="alert-message">
        <div class="alert-title"> {{ description }} </div>
        <div class="alert-description"> {{ body }} </div>
    </fadv-grid-row>
</fadv-grid>